import { ListSubheader, MenuItem, Select } from "@mui/material";
import EAEvolutionLineChart from "components/common/charts/EAEvolutionLineChart";
import EADialog from "components/common/EADialog";
import i18next from "i18next";
import { useMemo, useState } from "react";
import { CreditsafeIndicators } from "services/common/CreditsafeUtils";
import useStyles from "./CreditsafeHistoryModalStyle";
import EAEvolutionLineNotDataChart from "components/common/charts/EAEvolutionLineNotDataChart";
import { theme } from "style/globalStyle";

const getMinMaxForScore = (scoreType, data) => {
  switch(scoreType) {
    case CreditsafeIndicators.INTERNATIONAL_SCORE:
      // A=5, B=4, C=3, D=2, E=1
      return { min: 0, max: 6 };

    case CreditsafeIndicators.NATIONAL_SCORE:
      // Valeur 0-100
      return { min: 0, max: 100 };

    case CreditsafeIndicators.ACTIVITY_SECTOR_EXPOSURE:
      // A=4 (meilleur), B=3, C=2, D=1
      return { min: 0, max: 5 };

    case CreditsafeIndicators.COMPANY_EXPOSURE:
      // Valeur 1-4
      return { min: 0, max: 5 };

    case CreditsafeIndicators.FINANCIAL_STRENGTH:
      // A1=10 jusqu'à D=1
      return { min: 0, max: 11 };

    case CreditsafeIndicators.CREDIT_LIMIT:
      // Calculer le max dynamiquement à partir des données
      if (data && Array.isArray(data)) {
        const scores = data.map(item => item.score).filter(score => score != null && !isNaN(score));
        const maxValue = scores.length > 0 ? Math.max(...scores) : 1000000;
        // Ajouter une marge de 10% pour un meilleur affichage
        return { min: 0, max: Math.ceil(maxValue * 1.1) };
      }
      return { min: 0, max: 1000000 };

    case CreditsafeIndicators.PAYMENT_BEHAVIOR:
      // Calculer le max dynamiquement à partir des données
      if (data && Array.isArray(data)) {
        const scores = data.map(item => item.score).filter(score => score != null && !isNaN(score));
        const maxValue = scores.length > 0 ? Math.max(...scores) : 100;
        // Ajouter une marge de 10% pour un meilleur affichage
        return { min: 0, max: Math.ceil(maxValue * 1.1) };
      }
      return { min: 0, max: 100 };

    default:
      return { min: 0, max: 100 };
  }
};

const CreditsafeHistoryModal = ({isOpen = false, historyData, onClose = () => { } }) => {
  const { classes } = useStyles();
  const [selectedScore, setSelectedScore] = useState(CreditsafeIndicators.INTERNATIONAL_SCORE);

  const { min, max } = useMemo(() =>
    getMinMaxForScore(selectedScore, historyData?.[selectedScore]),
    [selectedScore, historyData]
  );

  return (
    <EADialog
      isOpen={isOpen}
      title={i18next.t('scoreEvolution')}
      hasActions={false}
      onClose={onClose}
      maxWidth="md"
    >
      <div className={classes.graphEvolutionDialog}>

        <Select
          id="creditsafe-score-choice"
          onChange={(event) => setSelectedScore(event.target.value)}
          value={selectedScore}
          style={{ width: "100%", backgroundColor: '#FFF' }}
          inputProps={{ className: classes.historyMenuItem }}
        >
          <ListSubheader sx={{textTransform: 'uppercase', fontWeight: 700, color: theme.palette.grey.grey400, fontSize: '10px'}} >{i18next.t("creditsafe.scores.score")}</ListSubheader>
            <MenuItem key={CreditsafeIndicators.INTERNATIONAL_SCORE} value={CreditsafeIndicators.INTERNATIONAL_SCORE} className={classes.historyMenuItem}>
              {i18next.t(`creditsafe.scores.internationalScoreShort`)}
            </MenuItem>
            <MenuItem key={CreditsafeIndicators.NATIONAL_SCORE} value={CreditsafeIndicators.NATIONAL_SCORE} className={classes.historyMenuItem}>
              {i18next.t(`creditsafe.scores.nationalScoreValueShort`)}
            </MenuItem>
          <ListSubheader sx={{textTransform: 'uppercase', fontWeight: 700, color: theme.palette.grey.grey400, fontSize: '10px'}}>{i18next.t("creditsafe.scores.subScores")}</ListSubheader>
            <MenuItem key={CreditsafeIndicators.CREDIT_LIMIT} value={CreditsafeIndicators.CREDIT_LIMIT} className={classes.historyMenuItem}>
              {i18next.t(`creditsafe.scores.${CreditsafeIndicators.CREDIT_LIMIT}`)}
            </MenuItem>
             <MenuItem key={CreditsafeIndicators.PAYMENT_BEHAVIOR} value={CreditsafeIndicators.PAYMENT_BEHAVIOR} className={classes.historyMenuItem}>
              {i18next.t(`creditsafe.scores.${CreditsafeIndicators.PAYMENT_BEHAVIOR}`)}
            </MenuItem>
             <MenuItem key={CreditsafeIndicators.ACTIVITY_SECTOR_EXPOSURE} value={CreditsafeIndicators.ACTIVITY_SECTOR_EXPOSURE} className={classes.historyMenuItem}>
              {i18next.t(`creditsafe.scores.${CreditsafeIndicators.ACTIVITY_SECTOR_EXPOSURE}`)}
            </MenuItem>
            <MenuItem key={CreditsafeIndicators.COMPANY_EXPOSURE} value={CreditsafeIndicators.COMPANY_EXPOSURE} className={classes.historyMenuItem}>
              {i18next.t(`creditsafe.scores.${CreditsafeIndicators.COMPANY_EXPOSURE}`)}
            </MenuItem>
            <MenuItem key={CreditsafeIndicators.FINANCIAL_STRENGTH} value={CreditsafeIndicators.FINANCIAL_STRENGTH} className={classes.historyMenuItem}>
              {i18next.t(`creditsafe.scores.${CreditsafeIndicators.FINANCIAL_STRENGTH}`)}
            </MenuItem>
        </Select>

        <div className={classes.graphEvolutionContent}>

          {(!historyData?.[selectedScore] || historyData?.[selectedScore].length === 0) &&
            <EAEvolutionLineNotDataChart/>
          }
          {historyData?.[selectedScore]?.length > 0 &&
            <EAEvolutionLineChart
              id="creditsafe-evolution-chart"
              data={historyData?.[selectedScore]}
              min={min}
              max={max}
          />
          }


        </div>
      </div>
    </EADialog>
  )
};

export default CreditsafeHistoryModal; 